<template>
<div class="chapter">
<div class="inner_page">
<p class="C472"><a id="page_2"></a>Section A</p>
<p class="C475"><strong>SETTING THE SCENE</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_ASETTING_THE_SCENE.vue?767f9a71